.root {
  min-width: 0;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 1.5rem 0;
}

.tab {
  background: #ffffff;
  border: 1px solid rgba(15, 43, 60, 0.2);
  border-radius: 999px;
  color: var(--color-text);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-small);
  padding: 8px 18px;
}

.tab:hover {
  border-color: var(--color-primary);
}

.tab[aria-selected="true"] {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-text-on-primary);
}

.tab:focus-visible,
.panel:focus-visible {
  outline: 3px solid var(--color-info-border);
  outline-offset: 2px;
}

.panel {
  min-width: 0;
}
